import { render, staticRenderFns } from "./WalletDropdown.vue?vue&type=template&id=02367fbc"
import script from "./WalletDropdown.vue?vue&type=script&lang=js"
export * from "./WalletDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports